import { L10n, loadCldr } from "@syncfusion/ej2-base";
import svData from "@syncfusion/ej2-cldr-data/main/sv/all.json";

loadCldr(svData);

L10n.load({
  sv: {
    schedule: {
      day: "Dag",
      week: "Vecka",
      workWeek: "Arbetsvecka",
      month: "Månad",
      year: "År",
      agenda: "Agenda",
      weekAgenda: "Veckoagenda",
      workWeekAgenda: "Arbetsveckoagenda",
      monthAgenda: "Månadsagenda",
      today: "Idag",
      noEvents: "Inga händelser",
      emptyContainer: "Det finns inga schemalagda händelser denna dag.",
      allDay: "Hela dagen",
      start: "Start",
      end: "Slut",
      more: "mer",
      close: "Stäng",
      cancel: "Avbryt",
      noTitle: "(Ingen titel)",
      delete: "Radera",
      deleteEvent: "Radera händelse",
      deleteMultipleEvent: "Radera flera händelser",
      selectedItems: "Valda objekt",
      deleteSeries: "Radera serie",
      edit: "Redigera",
      editSeries: "Redigera serie",
      editEvent: "Redigera händelse",
      createEvent: "Skapa",
      subject: "Ämne",
      addTitle: "Lägg till titel",
      moreDetails: "Mer information",
      moreEvents: "Fler händelser",
      save: "Spara",
      editContent: "Vill du redigera endast denna händelse eller hela serien?",
      deleteRecurrenceContent:
        "Vill du radera endast denna händelse eller hela serien?",
      deleteContent: "Är du säker på att du vill radera denna händelse?",
      deleteMultipleContent:
        "Är du säker på att du vill radera de valda händelserna?",
      newEvent: "Ny händelse",
      title: "Titel",
      location: "Plats",
      description: "Beskrivning",
      timezone: "Tidszon",
      startTimezone: "Starttidszon",
      endTimezone: "Sluttidszon",
      repeat: "Upprepa",
      saveButton: "Spara",
      cancelButton: "Avbryt",
      deleteButton: "Radera",
      recurrence: "Återkommande",
      wrongPattern: "Återkommande mönstret är inte giltigt.",
      seriesChangeAlert:
        "Ändringar som gjorts på specifika instanser av denna serie kommer att återställas och matcha serien igen.",
      createError:
        "Händelsens varaktighet måste vara kortare än hur ofta den återkommer. Förkorta varaktigheten eller ändra återkommande mönster i redigeraren.",
      recurrenceDateValidation:
        "Vissa månader har färre dagar än det valda datumet. För dessa månader kommer händelsen att ske på den sista dagen i månaden.",
      sameDayAlert:
        "Två förekomster av samma händelse kan inte ske på samma dag.",
      occurenceAlert:
        "En förekomst av ett återkommande möte kan inte schemaläggas om om det hoppar över en senare förekomst av samma möte.",
      editRecurrence: "Redigera återkommande",
      repeats: "Upprepas",
      alert: "Varning",
      startEndError: "Det valda slutdatumet inträffar före startdatumet.",
      invalidDateError: "Det angivna datumet är ogiltigt.",
      blockAlert:
        "Händelser kan inte schemaläggas inom den blockerade tidsperioden.",
      ok: "Ok",
      yes: "Ja",
      no: "Nej",
      occurrence: "Förekomst",
      series: "Serie",
      previous: "Föregående",
      next: "Nästa",
      timelineDay: "Tidslinje Dag",
      timelineWeek: "Tidslinje Vecka",
      timelineWorkWeek: "Tidslinje Arbetsvecka",
      timelineMonth: "Tidslinje Månad",
      expandAllDaySection: "Expandera",
      collapseAllDaySection: "Dölj",
      timelineYear: "Tidslinje År",
      editFollowingEvent: "Följande händelser",
      deleteTitle: "Radera händelse",
      editTitle: "Redigera händelse",
      beginFrom: "Börjar från",
      endAt: "Slutar vid",
      searchTimezone: "Sök tidszon",
      noRecords: "Inga poster hittades",
      of: "av",
    },
    recurrenceeditor: {
      none: "Ingen",
      daily: "Dagligen",
      weekly: "Veckovis",
      monthly: "Månadsvis",
      month: "Månad",
      yearly: "Årligen",
      never: "Aldrig",
      until: "Till",
      count: "Antal",
      first: "Första",
      second: "Andra",
      third: "Tredje",
      fourth: "Fjärde",
      last: "Sista",
      repeat: "Upprepa",
      repeatEvery: "Upprepa varje",
      on: "Upprepa på",
      end: "Slut",
      onDay: "Dag",
      days: "Dag(ar)",
      weeks: "Vecka(or)",
      months: "Månad(er)",
      years: "År",
      every: "varje",
      summaryTimes: "gång(er)",
      summaryOn: "på",
      summaryUntil: "till",
      summaryRepeat: "Upprepas",
      summaryDay: "dag(ar)",
      summaryWeek: "vecka(or)",
      summaryMonth: "månad(er)",
      summaryYear: "år",
    },
    formValidator: {
      required: "Fältet är obligatoriskt",
    },
  },
});
